<template>
  <pt-lab-order-lot-operate class="pt-lab-order-lot-operate__withData"></pt-lab-order-lot-operate>
</template>

<script>
import PtLabOrderLotOperate from './index'
export default {
  name: 'pt-lab-order-lot-operate__withData',
  components: {
    'pt-lab-order-lot-operate': PtLabOrderLotOperate
  }
}
</script>
